
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^((169|238|482|94)4|288|3340|3867|4935|5610|7405|7532|856|9618)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
